'use client';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
export const useStyles = () => ({
  ctaContainer: {
    p: '2rem 0',
    display: 'flex',
    justifyContent: 'center',
  },
});
